<template>
    <div>
        <el-table
        :data="adminRebateArr"
        style="width: 100%">
        <el-table-column label="门店名称">
          <template slot-scope="scope">
              <el-popover placement="right" trigger="hover">
                  {{scope.row.parent_name}}<span slot="reference">{{scope.row.parent_name | formatString(10)}}</span>
              </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="产品名称">
          <template slot-scope="scope">
              <el-popover placement="right" trigger="hover">
                  {{scope.row.title}}<span slot="reference">{{scope.row.title | formatString(10)}}</span>
              </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="产品类型/出行日期">
          <template slot-scope="scope">
            <div v-if="scope.row.order_style == 7">
              <div>{{scope.row.order_type == 6 ? '限时优惠' : '限时抢购'}}</div>
            </div>
            <div v-else>景区返利</div>
            <div>{{scope.row.date_in | formatTimestamp}}</div>
          </template>
        </el-table-column>
        <el-table-column label="购买人/手机号" width="110">
          <template slot-scope="scope">
            <div>{{scope.row.occupant_name}}</div>
            <div>{{scope.row.occupant_mobile}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="购买数量" width="80" />
        <el-table-column prop="price" label="付款金额">
          <template slot-scope="scope">
            {{scope.row.price + '元'}}
          </template>
        </el-table-column>
        <el-table-column prop="parent_money" label="佣金金额">
          <template slot-scope="scope">
            {{scope.row.parent_money + '元'}}
          </template>
        </el-table-column>
        <el-table-column prop="time" label="购买时间">
          <template slot-scope="scope">
            {{scope.row.time | formatTimestamp(1)}}
          </template>
        </el-table-column>
        <el-table-column prop="withdraw" label="状态">
          <template slot-scope="scope">
            <div :class="[orderStatus(scope.row.is_put_forward, 0)]">
              {{orderStatus(scope.row.is_put_forward, 1)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">            
            <span class="text-link" @click="$router.push({name:'VocationQR',query:{id:scope.row.id,type:scope.row.order_style}})">查看</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
export default {
    name: 'AdminDisplayList',
    props: ['adminRebateArr'],
    methods: {
        orderStatus(val, num) {
            let status = {};
            switch (val) {
                case 0 : status = {title: '可提现', color: 'text-info'}; break;
                case 1 : status = {title: '已提现', color: 'text-success'}; break;
                case 2 : status = {title: '冻结中', color: 'text-muted'}; break;
            }
            switch (num) {
                case 0 : return status.color
                case 1 : return status.title
            }
        }
    }
}
</script>

<style scoped>

</style>
